export const ASSET_IDS = {
    ETH: 16,
    RETH: 128,
    BTC: 37,
    DAI: 104,
    SOL: 143,
    ELK: 100,
    TQQQ: 116,
    INTC: 136,
    NIN: 23,
    klpNOR: 14,
    klpAGvN: 129,
    klpEUR: 12,
    klpVER: 13,
}